<div class="image-dialog-container" *ngIf="checked">
    <div class="header" mat-dialog-actions>
        <div class="navigation desktop">
            <div class="left">
                <button mat-button (dblclick)="delete()">Delete</button>
                <a mat-button [href]="imageSrc" target="_blank">Open in new tab</a>
            </div>
            <div class="middle">
                <button *ngIf="index != null" mat-button (click)="previous()">Previous</button>
                <button *ngIf="view" mat-button (click)="edit()">Edit</button>
                <button *ngIf="index != null" mat-button (click)="next()">Next</button>
            </div>
            <div class="right" *ngIf="!view">
                <button mat-button (click)="close()">Cancel</button>
                <button mat-button (click)="save()">Save</button>
            </div>
            <div class="right" *ngIf="view">
                <button mat-button (click)="close()">Close</button>
            </div>
        </div>

        <div class="navigation mobile">
            <div class="left">
                <button mat-button mat-dialog-close><mat-icon>arrow_back</mat-icon></button>
            </div>
            <div class="middle">
                <!-- <button mat-button (click)="previous()">Previous</button>
                <button *ngIf="view" mat-button (click)="edit()">Edit</button>
                <button mat-button (click)="next()">Next</button> -->
            </div>
            <div class="right">
                <button mat-button (click)="delete()">Delete</button>
                <button mat-button (click)="save()">Save</button>
            </div>
        </div>
    </div>

    <div *ngIf="view" class="view">
        <div class="image" [ngStyle]="{'background-image': getImageUrl(imageSrc)}"></div>
    </div>
    <div *ngIf="!view" class="edit">
        <pintura-editor
            #editor
            (process)="uploadEdittedImage($event)" 
            [src]="imageSrc" 
            [options]="options"
            [willRenderToolbar]="willRenderToolbar"
            ></pintura-editor>
    </div>
</div>

